module.exports = __webpack_public_path__ + "img/ptf.581b082b.png";